<ng-container>
  <ul class="space-y-3" style="flex-grow: 1; list-style: none; padding: 0; margin: 0;">
    <li class="flex items-start text-sm text-slate-700">
      <svg class="h-5 w-5 text-brand shrink-0 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"></path></svg>
      Sort, filter and Search all flows
    </li>
    <li class="flex items-start text-sm text-slate-700">
      <svg class="h-5 w-5 text-brand shrink-0 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"></path></svg>
      Add #tag to Group flows
    </li>
    <li class="flex items-start text-sm text-slate-700">
      <svg class="h-5 w-5 text-brand shrink-0 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"></path></svg>
      Flow run info, sort by runs, by errors
    </li>
  </ul>

  @if (showTiles) {
    <div class="grid grid-cols-3 gap-2 mt-4">
      <div class="bg-white p-2 rounded flex flex-col items-center justify-center shadow text-[11px] text-slate-800 h-14">
        <fa-icon icon="sort-alpha-up" class="text-sm mb-1"></fa-icon>
        Sort
      </div>
      <div class="bg-white p-2 rounded flex flex-col items-center justify-center shadow text-[11px] text-slate-800 h-14">
        <fa-icon icon="filter" class="text-sm mb-1"></fa-icon>
        Filter
      </div>
      <div class="bg-white p-2 rounded flex flex-col items-center justify-center shadow text-[11px] text-slate-800 h-14">
        <fa-icon icon="hashtag" class="text-sm mb-1"></fa-icon>
        Tag
      </div>
      <div class="bg-white p-2 rounded flex flex-col items-center justify-center shadow text-[11px] text-slate-800 h-14">
        <fa-icon icon="bars" class="text-sm mb-1"></fa-icon>
        Runs
      </div>
      <div class="bg-white p-2 rounded flex flex-col items-center justify-center shadow text-[11px] text-slate-800 h-14">
        <fa-icon icon="exclamation-circle" class="text-sm mb-1"></fa-icon>
        High Runs alert
      </div>
      <div class="bg-white p-2 rounded flex flex-col items-center justify-center shadow text-[11px] text-slate-800 h-14">
        <fa-icon icon="chart-bar" class="text-sm mb-1"></fa-icon>
        Sparklines
      </div>
      <div class="bg-white p-2 rounded flex flex-col items-center justify-center shadow text-[11px] text-slate-800 h-14">
        <fa-icon icon="clipboard" class="text-sm mb-1"></fa-icon>
        Flow Clipboard
      </div>
    </div>
  }
</ng-container>
